<!--
 * @Description: 
 * @Author: 
 * @Date: 2023-09-21 10:54:43
 * @LastEditTime: 2023-11-12 17:08:18
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="container">
    <div class="header">
      <div class="total_chose_box" style="display: block;">
       
        <span class="chose_tltle">请选择年份：</span>
        <select class="year_chose" disabled >
          <option>2024</option>
         
        </select>
        <span class="chose_tltle">月份：</span>
        <input class="chose_text_in" value="1-2月"  disabled />
        <span class="chose_tltle">请选择区域：</span>
        <select class="year_chose">
          <option>合阳城街道</option>
        
       
         
         
        </select>
        <button class="chose_enter">确定</button>
      </div>
    </div>

    <div class="content flex justify-around">
      <!-- 边框盒子 -->
      <LeftBox />
      <CenterBox />
      <RightBox />
    </div>
  </div>
</template>

<script>
import LeftBox from "../pages/views/left-box.vue";
import RightBox from "../pages/views/right-box";
import CenterBox from "../pages/views/center-box.vue";
export default {
  name: "mianIndex",
  props: {
    // msg: String,
  },
  components: {
    LeftBox,
    RightBox,
    CenterBox
  }
};
</script>

<style>
.container {
  height: 100vh;
  background-image: url("../assets/img/mian-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.header {
  height: 11%;
  /* border: 1px solid red; */
  position: relative;
  /* background-image: url("../assets/img/head_bg.png");
  background-size: 100% 100%; */
}

.total_chose_box {
  /* height: 57px; */
  /* border: 1px solid greenyellow; */
  position: absolute;
  bottom: 2px;
}

.chose_tltle {
  margin-left: 22px;
  display: block;
  float: left;
  color: white;
}

.year_chose {
  background-color: transparent;
  color: #72e3ff;
  border: #00c0ef 2px solid;
  width: 120px;
  text-indent: 0.6em;
  border-radius: 5px;
  float: left;

}



.chose_text_in {
    background-color: transparent;
    color: #72e3ff;
    border: #00c0ef 2px solid;
    width: 120px;
    text-indent: 0.6em;
    border-radius: 5px;
    float: left;
}



.chose_enter {
    background-color: #00c0ef;
    color: white;
    border: #00cdff 2px solid;
    width: 50px;
    border-radius: 5px;
    float: left;
    margin-left: 20px;
    cursor: pointer;
}

.content {
  /* border: 1px solid white; */
  height: calc(100vh - 114px);
  padding: 0 6px 0 6px;
}

.title-box01 {
  height: 100%;
  border-radius: 10px;
  border: 1px #0174f5 solid;
  padding: 1px;
  box-sizing: border-box;
}

.title-box02 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 2px solid #016ae0;
  border-radius: 10px;
}

.title-name {
  width: 44%;
  height: 4%;
  background-image: url(../assets/img/tit01s.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  font-size: 14px;
  font-family: "微软雅黑";
  color: #ffffff;
  text-align: center;
}

table {
  background-color: transparent;
  border-spacing: 0;
}

td,
th {
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/homePge.vue